import { ReactNode } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '@/components/AuthProvider';
import { LoadingFallback } from '@/components/LoadingFallback';

interface ProtectedRouteProps {
  children: ReactNode;
  requireAuth?: boolean;
}

export function ProtectedRoute({ children, requireAuth = true }: ProtectedRouteProps) {
  const { user, loading } = useAuth();
  const location = useLocation();

  // Debug logging
  console.log('ProtectedRoute Debug:', { user: !!user, loading, requireAuth, path: location.pathname });

  if (loading) {
    return <LoadingFallback />;
  }

  if (requireAuth && !user) {
    // Redirect to auth page with return URL
    return <Navigate to="/auth" state={{ from: location }} replace />;
  }

  if (!requireAuth && user) {
    // If user is already authenticated and trying to access auth page, redirect to dashboard
    return <Navigate to="/" replace />;
  }

  return <>{children}</>;
}